import Service from '@/Network/Services/Service'
import { DoctorStationApiResponse } from '../Types/Responses/ReportsResponses'
import request from '@/Network/Requests/request'

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum ReportSortableFields {
  DOCTOR_NAME = 'doctor',
  STATION_DATE = 'date',
  CREATED_AT = 'created_at'
}

export interface PaginatedReportsResponse {
  data: DoctorStationApiResponse[]
  total: number
  page: number
  limit: number
}

export type GetReportsFilters = {
  companyIds?: number[]
  healthUnitIds?: number[]
  positionIds?: number[]
  doctorIds?: number[]
  operationalGroups?: string[]
  startDate: string
  endDate: string
  isChecked?: boolean
  paymentTiming?: 'IMMEDIATE' | 'FLOW'
  /**
   * `true` = apenas plantões com excepcionalidade aprovada; `false` = apenas sem.
   * `undefined` não vai na query (todos). Mesmo critério da coluna
   * "É Excepcionalidade?" do relatório e do filtro da tela de Consulta.
   */
  hasException?: boolean
  page?: number
  limit?: number
  orderName?: ReportSortableFields | string
  order?: OrderDirection | string
}

export type ReportXlxsRequest = Omit<GetReportsFilters, 'page' | 'limit'> & {
  columns?: string[]
}

export default class ReportsService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/reports'
  }

  async getReports(filters: GetReportsFilters): Promise<PaginatedReportsResponse> {
    try {
      const path = `${this.prefix}/doctor-stations`
      const { data: apiResponse } = await request.get<PaginatedReportsResponse>(path, filters)

      return apiResponse
    } catch (e) {
      console.error('Erro ao buscar relatórios', e)
      throw new Error('Ocorreu um erro ao buscar os relatórios.')
    }
  }

  async exportRelatoryXlsx(filters: ReportXlxsRequest): Promise<HTMLAnchorElement> {
    try {
      const path = `${this.prefix}/doctor-stations/export`
      const { data } = await request.get<BlobPart>(path, filters, undefined, 'blob')

      const url = window.URL.createObjectURL(
        new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
      )
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'relatorio_doctor_stations.xlsx')
      return link
    } catch (e) {
      console.error('Erro ao exportar relatório', e)
      throw new Error('Ocorreu um erro ao exportar o relatório.')
    }
  }
}
